import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
import {
  GetOne_CancelReasons_Data,
  UpdateOne_CancelReasons_Data,
} from '../../Redux/Actions/CancelReasons_Actions';
import { Notify } from '../../Utility/Notify';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

export const Updatecncelreason = () => {
  const theme      = useTheme();
  const isDark     = theme.palette.mode === 'dark';
  const sidebarWidth = useSidebarWidth();
  const { id }     = useParams();
  const dispatch   = useDispatch();

  const [reason,   setReason]   = useState('');
  const [loading,  setLoading]  = useState(false);
  const [userlogin, setUserlogin] = useState(null);

  /* ── User from localStorage ── */
  useEffect(() => {
    const u = JSON.parse(localStorage.getItem('user'));
    if (u) setUserlogin(u);
  }, []);

  /* ── Fetch one cancel reason ── */
  useEffect(() => {
    dispatch(GetOne_CancelReasons_Data(id));
  }, [dispatch, id]);

  const res_get = useSelector((state) => state.AllCancelReasons.Cancelreason);
  const one_CancelReason = res_get?.data || null;

  useEffect(() => {
    if (one_CancelReason) setReason(one_CancelReason.cancelreason || '');
  }, [one_CancelReason]);

  /* ── Submit ── */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reason.trim()) {
      Notify('error', 'Reason cannot be empty', 'error');
      return;
    }
    setLoading(true);
    await dispatch(UpdateOne_CancelReasons_Data(id, { cancelreason: reason }));
    setLoading(false);
  };

  const res_update = useSelector((state) => state.AllCancelReasons.Updatecancelreason);
  useEffect(() => {
    if (loading === false && res_update) {
      if (res_update.status === 200) {
        Notify('success', 'Updated Successfully', 'success');
        setReason('');
      }
    }
  }, [loading, res_update]);

  /* ── Routes based on role ── */
  const role = userlogin?.data?.role;
  const homeRoute = role === 'Admin' ? '/AllLeadsForAdmin' : role === 'Marketer' ? '/ALLLeadsForMarketer' : '/';
  const cancelRoute = '/CancelReasons';

  /* ── Style helpers ── */
  const inputSt = {
    width: '100%',
    padding: '12px 16px',
    borderRadius: '12px',
    border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
    backgroundColor: isDark ? '#151827' : '#ffffff',
    color: isDark ? '#f1f5f9' : '#0f172a',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.2s',
    fontFamily: "'DM Sans', sans-serif",
    boxSizing: 'border-box',
  };

  const labelSt = {
    display: 'block',
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: isDark ? '#9ca3af' : '#64748b',
    marginBottom: '8px',
    fontFamily: "'DM Sans', sans-serif",
  };

  /* ─────────────────────────────────────────────── */
  return (
    <div style={{
      position: 'fixed',
      top: '50px',
      left: sidebarWidth,
      right: 0,
      bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflowY: 'auto',
      overflowX: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    }}>

      {/* ── Breadcrumb ── */}
      <section style={{ padding: '16px 20px 0', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px' }}>
          <Link to={homeRoute} style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500, fontFamily: "'DM Sans',sans-serif" }}>
            Home
          </Link>
          <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
          <Link to={cancelRoute} style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500, fontFamily: "'DM Sans',sans-serif" }}>
            Cancel Reasons
          </Link>
          <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
          <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600, fontFamily: "'DM Sans',sans-serif" }}>
            Update Reason
          </span>
        </div>
      </section>

      {/* ── Main Content ── */}
      <section style={{ flex: 1, padding: '20px 20px 48px', display: 'flex', flexDirection: 'column' }}>

        {/* Page Header */}
        <div style={{ marginBottom: '20px' }}>
          <div style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: isDark ? '#6b7280' : '#94a3b8', marginBottom: '4px', fontFamily: "'DM Sans', sans-serif" }}>
            SETTINGS
          </div>
          <h1 style={{ fontSize: '24px', fontWeight: 700, color: isDark ? '#f1f5f9' : '#0f172a', margin: '0 0 4px', letterSpacing: '-0.4px', fontFamily: "'DM Sans', sans-serif" }}>
            UPDATE CANCEL REASON
          </h1>
          <p style={{ fontSize: '13px', color: isDark ? '#6b7280' : '#64748b', margin: 0, fontFamily: "'DM Sans', sans-serif" }}>
            Edit the cancel reason details below.
          </p>
        </div>

        {/* Form Card */}
        <div style={{
          backgroundColor: isDark ? '#1e2132' : '#ffffff',
          borderRadius: '16px',
          padding: '32px 36px',
          boxShadow: isDark ? '0 8px 32px rgba(0,0,0,0.35)' : '0 2px 16px rgba(0,0,0,0.06)',
          border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0',
          maxWidth: '600px',         /* narrower card — form is simple */
          width: '100%',
        }}>

          <form onSubmit={handleSubmit}>

            {/* Reason Field */}
            <div style={{ marginBottom: '28px' }}>
              <label style={labelSt}>Cancel Reason</label>
              <input
                type="text"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Enter cancel reason..."
                style={inputSt}
                onFocus={(e) => {
                  e.target.style.borderColor = '#2563eb';
                  e.target.style.boxShadow = '0 0 0 3px rgba(37,99,235,0.12)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = isDark ? '#2d3248' : '#e2e8f0';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>

            {/* Info Note */}
            <div style={{
              marginBottom: '28px',
              padding: '14px 16px',
              borderRadius: '10px',
              backgroundColor: isDark ? 'rgba(37,99,235,0.08)' : 'rgba(37,99,235,0.04)',
              border: `1px solid ${isDark ? 'rgba(37,99,235,0.2)' : 'rgba(37,99,235,0.15)'}`,
            }}>
              <p style={{ fontSize: '12px', color: isDark ? '#93c5fd' : '#6b7280', margin: 0, fontFamily: "'DM Sans', sans-serif" }}>
                Changes will take effect immediately after saving.
              </p>
            </div>

            {/* Divider */}
            <div style={{ height: '1px', backgroundColor: isDark ? '#2a2f45' : '#e8eaf0', marginBottom: '24px' }} />

            {/* Submit Button */}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <button
                type="submit"
                disabled={loading}
                style={{
                  padding: '13px 36px',
                  borderRadius: '10px',
                  border: 'none',
                  background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
                  color: '#fff',
                  fontSize: '13px',
                  fontWeight: 700,
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  transition: 'all 0.2s',
                  boxShadow: '0 4px 16px rgba(29,78,216,0.35)',
                  fontFamily: "'DM Sans', sans-serif",
                  minWidth: '220px',
                }}
                onMouseEnter={(e) => {
                  if (!loading) {
                    e.currentTarget.style.transform = 'translateY(-1px)';
                    e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)';
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'none';
                  e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)';
                }}
              >
                {loading ? (
                  <>
                    <CircularProgress size={15} style={{ color: '#fff' }} />
                    <span>Saving...</span>
                  </>
                ) : (
                  <>
                    {/* sync icon */}
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <polyline points="23 4 23 10 17 10"/>
                      <polyline points="1 20 1 14 7 14"/>
                      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
                    </svg>
                    <span>Update Cancel Reason</span>
                  </>
                )}
              </button>
            </div>

          </form>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        flexShrink: 0,
        padding: '14px 20px',
        borderTop: `1px solid ${isDark ? '#2a2f45' : '#e8eaf0'}`,
        fontSize: '12px',
        color: isDark ? '#4b5563' : '#9ca3af',
        fontFamily: "'DM Sans', sans-serif",
      }}>
        <span>© 2026 EstateCore CRM. Smart CRM that connects customers, data, and sales in one safe place.</span>
      </footer>

    </div>
  );
};
